import React from 'react';

import {
  shallowEqual,
  useSelector,
} from 'react-redux';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  Flex,
} from 'web-styled';

import Item from '../Item';

const mapState = state => ({
  products: coreSelectors.getResourceMappedList(
    'products',
  )(state),
  productPlans: coreSelectors.getResourceMappedList(
    'productPlans',
  )(state),
});

const ProItems = () => {
  const {
    products,
    productPlans,
  } = useSelector(mapState, shallowEqual);

  return (
    <Flex
      column
      flex="0 0 1000px"
      spacing={30}
    >
      {productPlans.map((plan) => (
        <Item
          key={plan.id}
          name={plan.name}
          amount={plan.amount}
          currency={plan.currency}
          interval={plan.interval}
          description={plan.description}
          imageUrl={plan.image?.url}
          videoUrl={plan.video_url}
        />
      ))}

      {products.map((product) => (
        <Item
          key={product.id}
          name={product.name}
          amount={product.amount}
          currency={product.currency}
          description={product.description}
          imageUrl={product.image?.url}
          videoUrl={product.video_url}
        />
      ))}
    </Flex>
  );
};

export default ProItems;
